import styled from 'styled-components'
import { SUBSCRIPTION_PRICE } from '../../constants'
import { useGetUserInfo } from '../../services/api/user-info.hooks'
import { Border, Colors, Spacing } from '../../styles'
import {
    SUBSCRIBE_CHARGE_TEXT,
    daysLeftText,
    formatTrialEndDate,
    hasManageableSubscriptionStatus,
} from '../../utils/subscription'
import Flex from '../atoms/Flex'
import { BodySmall, TitleMedium } from '../atoms/typography/Typography'
import { ManageBillingButton, SubscribeButton } from './SubscriptionButtons'

const Panel = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${Spacing._16};
    padding: ${Spacing._16};
    border: ${Border.stroke.medium} solid ${Colors.background.border};
    border-radius: ${Border.radius.small};
    background-color: ${Colors.background.white};
`

const Row = styled(Flex)`
    min-width: 0;
`

const BillingSettings = () => {
    const { data: userInfo } = useGetUserInfo()
    const isSubscribed = Boolean(userInfo?.is_subscribed)
    const isInTrial = Boolean(userInfo?.is_in_trial)
    const hasManageableSubscription = hasManageableSubscriptionStatus(userInfo?.subscription_status, isSubscribed)
    const daysRemaining = userInfo?.trial_days_remaining ?? 0
    const trialEndDate = formatTrialEndDate(userInfo?.trial_ends_at)

    let title = trialEndDate ? `Trial ended ${trialEndDate}` : 'Trial ended'
    let detail =
        userInfo?.has_product_access === false
            ? `Read-only · subscribe for ${SUBSCRIPTION_PRICE} to edit`
            : `${SUBSCRIPTION_PRICE}`
    if (isSubscribed) {
        title = 'Active subscription'
        // Earlier subscribers keep the price they signed up at; the billing portal shows the real amount
        detail = 'Billed monthly'
    } else if (hasManageableSubscription) {
        title = 'Payment needs attention'
        detail = 'Update billing to keep editing'
    } else if (isInTrial) {
        title = trialEndDate ? `Free trial · ends ${trialEndDate}` : 'Free trial'
        detail = `${daysLeftText(daysRemaining)} · ${SUBSCRIBE_CHARGE_TEXT}`
    }

    return (
        <Panel>
            <Row justifyContent="space-between" alignItems="center" gap={Spacing._16}>
                <Flex column gap={Spacing._4}>
                    <TitleMedium>{title}</TitleMedium>
                    <BodySmall color="light">{detail}</BodySmall>
                </Flex>
                {hasManageableSubscription ? <ManageBillingButton /> : <SubscribeButton />}
            </Row>
        </Panel>
    )
}

export default BillingSettings
